Pluswerk.PlusProject.Utility = Pluswerk.PlusProject.Utility || {};

/**
 * DetectBrowserController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Utility.DetectBrowserController = function () {
  var browser = bowser.name;
  browser = browser.replace(/\s+/g, '-').toLowerCase();
  $html.addClass(browser);
};
